/* DUI.TreeView.js */
(function ($) {
    var pluginName = 'DUITreeView';
    var internals = {
        iterateAncestors: function (node, callback) {
            function nextParent(node) { return node.parent() }

            if (node.length > 0) {
                var goNextParent = true;
                while (goNextParent) {
                    if (node.hasClass('DUITreeView')) {
                        goNextParent = false;
                        continue;
                    }
                    node = nextParent(node.parent());

                    if (node[0].nodeName.toUpperCase() !== 'UL') {
                        continue;
                    }

                    callback(node);
                }
            }
        },
        iterateDescendants: function (node, callback) {
            if (node.length > 0) {
                node.parent().find('li').each(function () {
                    callback($(this));
                })
            }
        },
        iterateChildren: function (node, callback) {
            if (node.length > 0) {
                node.parent().children('ul').children('li').each(function () {
                    callback($(this));
                })
            }
        },
        genRandomString: function (len) {
            len = (typeof len === "undefined") ? 5 : len;
            var s = [];
            var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < len; i++) { s.push(p.charAt(Math.floor(Math.random() * p.length))); }
            return s.join('');
        }
    }

    var methods = {
        init: function (options) {
            var settings = $.extend({
                check: function () { },
                expand: function () { },
                collapse: function () { },
                select: function () { },
                cbCheckAll: function () { },
                cbUncheckAll: function () { },
                cbCheckChildren: function () { },
                cbUncheckChildren: function () { },
                cbCheckSiblings: function () { },
                cbUncheckSiblings: function () { },
                cbCheckAncestors: function () { },
                cbUncheckAncestors: function () { },
                cbCheckDescendants: function () { },
                cbUncheckDescendants: function () { },
                cbCheckNodeLevel: function () { },
                inlineMenu: false,
                showBorder: false,
                compact: false,
                singleSelection: false,         
                checkAllText: locale.get("Check all"),
                uncheckAllText: locale.get("Uncheck all")
            }, options);

            return $(this).each(function (index) {
                var oThis = $(this), data = oThis.data(pluginName);
                if (!data) {
                    oThis.data(pluginName, { target: oThis, settings: settings })
                }

                //Generate ID for radio group
                settings.radiogroup = internals.genRandomString(12);
                settings.mouseEventID = internals.genRandomString(12);
                settings.updateCompactText = Helpers.throttle(methods.updateCompactText, 250);
                settings.updateHeight = Helpers.throttle(methods.updateHeight, 250);

                oThis.addClass('DUITreeView');
                
                if (settings.compact) {
                    var compactButton = $('<button type="button" class="DUITreeCompactButton"><span class="DUITreeCompactButton-ui-icon"></span><span class="DUITreeCompactButton-ui-text">No selection</span></button>').insertBefore(oThis);

                    var compactSearch = $('<form class="DUITreeCompactButton DUITreeCompactSearch"><input type="text" class="DUITreeSearchInput"><button type="button"  class="DUITreeSearchButton"><svg width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15.6398 13.54l-3.8375-3.8375c.5904-.9406.922-2.0526.905-3.2583C12.7243 2.9977 9.7258 0 6.2633 0 2.8053 0 0 2.8056 0 6.2632c0 3.4622 2.9985 6.461 6.4442 6.4442 1.165.0168 2.2422-.2947 3.186-.8327l3.8374 3.8375c.3686.3837.9792.3837 1.3396 0l.9774-.9413c.3703-.381.2352-.8557-.1448-1.231zM1.9188 6.2632c0-2.404 1.9425-4.3444 4.3444-4.3444 2.3908 0 4.5254 2.1348 4.5254 4.5254 0 2.4016-1.9414 4.3444-4.3444 4.3444-2.391 0-4.5254-2.1348-4.5254-4.5254z" fill="currentColor"/></svg></button></form>');

                    if (settings.isSearchable) {
                        compactSearch.insertBefore(oThis);
                        compactSearch.click(function(event) {
                            event.stopImmediatePropagation();
                        });
                    }

                    oThis.addClass('DUITreeCompact');

                    compactButton.click(function () {
                        if (oThis.hasClass('DUITreeCompact-expanded')) {
                            oThis.removeClass('DUITreeCompact-expanded');

                            compactButton.add(compactSearch).removeClass('DUITreeCompact-expanded');

                            if (window.IsStoryboard)
                                Storyboard.LayoutDesigner.autoUpdateLayoutElements();

							$(document).unbind('mousedown.DUITreeView' + settings.mouseEventID);
						} else {
							oThis.addClass('DUITreeCompact-expanded');
							compactButton.add(compactSearch).addClass('DUITreeCompact-expanded');
							compactSearch.find('.DUITreeSearchInput').focus();
							settings.updateHeight.apply(oThis);
							$(document).bind('mousedown.DUITreeView' + settings.mouseEventID, function(evt){
								if (!$.contains(oThis[0], evt.target) && evt.target !== oThis[0] && 
									!$.contains(compactButton[0], evt.target) && evt.target !== compactButton[0] &&
									!$.contains(compactSearch[0], evt.target) && evt.target !== compactSearch[0] &&
									!$(evt.target).hasClass('downloadcontainer') &&
									$('.downloadcontainer').has(evt.target).length === 0 &&
									!$(evt.target).is('#hfilterContainer_ct') &&
									$('#hfilterContainer_ct').has(evt.target).length === 0) {
										oThis.removeClass('DUITreeCompact-expanded');
										compactButton.add(compactSearch).removeClass('DUITreeCompact-expanded');

                                    if (window.IsStoryboard) {
                                        GeneralSettings.validateMinMaxSelections($('#hfilterTree'));
										Storyboard.LayoutDesigner.autoUpdateLayoutElements();
										if (window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CHART) {
											DeckFilters.bindOverview()
											ChartCreatorSetup.loadContentForDeckSettings();
										}
									}
                                        
                                        $(document).unbind('mousedown.DUITreeView' + settings.mouseEventID);
                                }
                            });
                        }
                    });
                }

                if (!settings.showBorder) {
                    oThis.addClass('DUITreeViewNoBorder');
                }

                if (settings.inlineMenu) {
                    oThis.addClass('DUITreeViewHasMenu');
                }

                if (settings.singleSelection) {
                    oThis.addClass('DUITreeViewSingleSelection');
                }

                //IE<8 user-select
                oThis[0].onselectstart = function () { return false };

                //Bind events, assume no existing LIs
                oThis.delegate('li', 'click', function (evt) {
                    methods.handleEvt.apply(oThis, [evt]);
                });
                if (settings.checkAllEnabled && !settings.singleSelection && !settings.isExportPanel) {

                    oThis.prepend('<div><a class="DUITreeCheckAll">' + settings.checkAllText + '</a>'+
                        '<a class= "DUITreeUnCheckAll">' + settings.uncheckAllText +'</a ></div > ');
                
                    oThis.delegate('a.DUITreeCheckAll', 'click', function () {
                        Storyboard.HFilterLayout.selectAllNodes(true, "#hfilterTree", true);
                    });

                    oThis.delegate('a.DUITreeUnCheckAll', 'click', function () {
                        Storyboard.HFilterLayout.selectAllNodes(false, "#hfilterTree", true);
                    });
                }
                
                if (settings.inlineMenu) {
                    var mHTML = [];
                    mHTML.push('<li class="DUITreeViewInlineMenu DUITreeViewInlineMenuDisabled">');
                    mHTML.push('<ul>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuCheckAll" title="Check All"></li>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuUncheckAll" title="Uncheck All"></li>');
                    mHTML.push('<li class="DUITreeViewMIDivider"></item>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuCheckSiblings" title="Check Siblings"></li>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuUncheckSiblings" title="Uncheck Siblings"></li>');
                    mHTML.push('<li class="DUITreeViewMIDivider"></item>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuCheckChildnodes" title="Check Child nodes"></li>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuUncheckChildnodes" title="Uncheck Child nodes"></li>');
                    mHTML.push('<li class="DUITreeViewMIDivider"></item>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuCheckAncestors" title="Check Ancestors"></li>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuUncheckAncestors" title="Uncheck Ancestors"></li>');
                    mHTML.push('<li class="DUITreeViewMIDivider"></item>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuCheckDescendants" title="Check Descendants"></li>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuUncheckDescescendats" title="Uncheck Descendants"></li>');
                    mHTML.push('<li class="DUITreeViewMIDivider"></item>');
                    mHTML.push('<li class="DUITreeViewMI DUITreeViewInlineMenuCheckLevel" title="Check Specific Level"></li>');
                    mHTML.push('</ul>');
                    mHTML.push('</li>');

                    oThis.prepend(mHTML.join(''));

                    //Menu events
                    oThis.delegate('li.DUITreeViewInlineMenuCheckAll', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.checkAll.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbCheckAll();

                        if ($(this).hasClass('DUITreeViewMIChecked'))
                            $(this).removeClass('DUITreeViewMIChecked');
                        else
                            $(this).addClass('DUITreeViewMIChecked');
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuUncheckAll', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.uncheckAll.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbUncheckAll();
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuCheckSiblings', 'click', function () {
                        var settings = oThis.data(pluginName).settings;

                        var callback = function (node) {
                            node.find(" > span").addClass("selected");
                            if ($("#ddlShownHFiltersType").val() == 4) {
                                methods.checkDescendants.apply(oThis, [{ rootElement: oThis, disable: true }]);
                                settings.cbCheckDescendants(node.find('span.selected').prev('input').val());
                            }
                            node.find(" > span").removeClass("selected");
                       }

                        methods.checkSiblings.apply(oThis, [{ rootElement: oThis, callback: callback }]);
                        var parentNodeId = oThis.find('span.selected').parent().parent().parent().children('input').val();
                        if (typeof parentNodeId === "undefined") { parentNodeId = 0; }
                        settings.cbCheckSiblings(parentNodeId);

                        for (var i = 0; i < Storyboard.GeneralSettings.hFiltersAdmin.length; i++) {
                            var hfilter = Storyboard.GeneralSettings.hFiltersAdmin[i];
                            if (hfilter.DisplayID == oThis.find('span.selected').prev('input').val()) {
                                if ($(this).hasClass('DUITreeViewMIChecked')) // later in code this class is removed
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowSiblings = false;
                                else
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowSiblings = true;
                            }
                        }

                        if ($(this).hasClass('DUITreeViewMIChecked'))
                            $(this).removeClass('DUITreeViewMIChecked');
                        else
                            $(this).addClass('DUITreeViewMIChecked');
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuUncheckSiblings', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.uncheckSiblings.apply(oThis, [{ rootElement: oThis }]);
                        var parentNodeId = oThis.find('span.selected').parent().parent().parent().children('input').val();
                        if (typeof parentNodeId === "undefined") { parentNodeId = 0; }
                        settings.cbUncheckSiblings(parentNodeId);
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuCheckChildnodes', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.checkChildren.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbCheckChildren(oThis.find('span.selected').prev('input').val());

                        for (var i = 0; i < Storyboard.GeneralSettings.hFiltersAdmin.length; i++) {
                            var hfilter = Storyboard.GeneralSettings.hFiltersAdmin[i];
                            if (hfilter.DisplayID == oThis.find('span.selected').prev('input').val()) {
                                if ($(this).hasClass('DUITreeViewMIChecked')) // later in code this class is removed
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowLevelBelow = false;
                                else
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowLevelBelow = true;
                            }
                        }

                        if ($(this).hasClass('DUITreeViewMIChecked'))
                            $(this).removeClass('DUITreeViewMIChecked');
                        else
                            $(this).addClass('DUITreeViewMIChecked');
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuUncheckChildnodes', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.uncheckChildren.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbUncheckChildren(oThis.find('span.selected').prev('input').val());
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuCheckAncestors', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.checkAncestors.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbCheckAncestors(oThis.find('span.selected').prev('input').val());

                        for (var i = 0; i < Storyboard.GeneralSettings.hFiltersAdmin.length; i++) {
                            var hfilter = Storyboard.GeneralSettings.hFiltersAdmin[i];
                            if (hfilter.DisplayID == oThis.find('span.selected').prev('input').val()) {
                                if ($(this).hasClass('DUITreeViewMIChecked')) // later in code this class is removed
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowParents = false;
                                else
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowParents = true;
                            }
                        }

                        if ($(this).hasClass('DUITreeViewMIChecked')) {
                            $(this).removeClass('DUITreeViewMIChecked');
                        }
                        else
                            $(this).addClass('DUITreeViewMIChecked');
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuUncheckAncestors', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.uncheckAncestors.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbUncheckAncestors(oThis.find('span.selected').prev('input').val());
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuCheckDescendants', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.checkDescendants.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbCheckDescendants(oThis.find('span.selected').prev('input').val());

                        for (var i = 0; i < Storyboard.GeneralSettings.hFiltersAdmin.length; i++) {
                            var hfilter = Storyboard.GeneralSettings.hFiltersAdmin[i];
                            if (hfilter.DisplayID == oThis.find('span.selected').prev('input').val()) {
                                if ($(this).hasClass('DUITreeViewMIChecked')) // later in code this class is removed
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowChildren = false;
                                else
                                    Storyboard.GeneralSettings.hFiltersAdmin[i].AlwaysShowChildren = true;
                            }
                        }

                        if ($(this).hasClass('DUITreeViewMIChecked'))
                            $(this).removeClass('DUITreeViewMIChecked');
                        else
                            $(this).addClass('DUITreeViewMIChecked');
                    });
                    oThis.delegate('li.DUITreeViewInlineMenuUncheckDescescendats', 'click', function () {
                        var settings = oThis.data(pluginName).settings;
                        methods.uncheckDescendants.apply(oThis, [{ rootElement: oThis }]);
                        settings.cbUncheckDescendants(oThis.find('span.selected').prev('input').val());

                    });
                    oThis.delegate('li.DUITreeViewInlineMenuCheckLevel', 'click', function () {
                        var callback = function (node) {
                            node.find(" > span").addClass("selected");
                            if ($("#ddlShownHFiltersType").val() == 4) {
                                methods.checkDescendants.apply(oThis, [{ rootElement: oThis, disable: true }]);
                                settings.cbCheckDescendants(node.find('span.selected').prev('input').val());
                            }
                            node.find(" > span").removeClass("selected");
                        }
                        var settings = oThis.data(pluginName).settings;
                        methods.checkNodeLevel.apply(oThis, [{ callback: settings.cbCheckNodeLevel, callback1: callback }]);
                    });
                }
            })
        },
        renderRootNode: function (options) {
            var settings = $(this).data(pluginName).settings;
            var rootElement = $(this).data(pluginName).target;

            var selectHfilterString = settings.inlineMenu === true ? 'onclick="selectHFilterButtons($(this).parent().find(\'input\').is(\':checked\'), $(this).parent().find(\'input\').val())"' : '';

            var child = options.child, conHTML = [];
            var checked = (typeof child.checked !== "undefined" && child.checked) ? ' checked="checked"' : '';
            var disabled = (typeof child.disabled !== "undefined" && child.disabled) ? ' disabled="disabled"' : '';
            var value = (typeof child.value !== "undefined") ? child.value : -1;
            var name = (typeof child.name !== "undefined") ? child.name : '[No Name]';

            conHTML.push('<li class="collapsed">');

            if (settings.singleSelection) {
                conHTML.push('<input type="radio" name="' + settings.radiogroup + '" value="' + value + '"' + checked + '' + disabled + '/><span ' + selectHfilterString + '>' + name + '</span>');
            } else {
                conHTML.push('<input type="checkbox" value="' + value + '"' + checked + '' + disabled + '/><span ' + selectHfilterString + '>' + name + '</span>');
            }
            conHTML.push('</li>');

            rootElement.append(conHTML.join(''));
            if (options.selected) {
                rootElement.children('li.expanded').eq(0).children('span').addClass('selected');
                if (settings.inlineMenu) {
                    rootElement.children('.DUITreeViewInlineMenu').removeClass('DUITreeViewInlineMenuDisabled');
                }
            }

            if (settings.compact) {
                settings.updateCompactText.apply(rootElement);
            }
		},
		renderRootNodes: function (options) {
			var settings = $(this).data(pluginName).settings;
			var rootElement = $(this).data(pluginName).target;

			var selectHfilterString = settings.inlineMenu === true ? 'onclick="selectHFilterButtons($(this).parent().find(\'input\').is(\':checked\'), $(this).parent().find(\'input\').val())"' : '';

			var children = options.children, child, conHTML = [];

			for (var i in children) {
				child = children[i];

				var checked = (typeof child.checked !== "undefined" && child.checked) ? ' checked="checked"' : '';
				var disabled = (typeof child.disabled !== "undefined" && child.disabled) ? ' disabled="disabled"' : '';
				var value = (typeof child.value !== "undefined") ? child.value : -1;
				var name = (typeof child.name !== "undefined") ? child.name : '[No Name]';

				var nonExpandable = '';
				if (typeof child.expandable !== "undefined" && child.expandable)
					nonExpandable = ' nonexpandable';

				conHTML.push('<li class="collapsed' + nonExpandable + '">');

				if (settings.singleSelection) {
					conHTML.push('<input type="radio" name="' + settings.radiogroup + '" value="' + value + '"' + checked + '' + disabled + '/><span ' + selectHfilterString + '>' + name + '</span>');
				} else {
					conHTML.push('<input type="checkbox" value="' + value + '"' + checked + '' + disabled + '/><span ' + selectHfilterString + '>' + name + '</span>');
				}
				conHTML.push('</li>');
			}

			rootElement.append(conHTML.join(''));

			if (settings.compact) {
				settings.updateCompactText.apply(rootElement);
			}
		},
        renderChildNodes: function (options) {
            var settings = $(this).data(pluginName).settings;
            var rootElement = $(this).data(pluginName).target;

            function pushChild(child) {
                var selectHfilterString = settings.inlineMenu === true ? 'onclick="selectHFilterButtons($(this).parent().find(\'input\').is(\':checked\'), $(this).parent().find(\'input\').val())"' : '';

                var checked = (typeof child.checked !== "undefined" && child.checked) ? ' checked="checked"' : '';
                var disabled = (typeof child.disabled !== "undefined" && child.disabled) ? ' disabled="disabled"' : '';
                var value = (typeof child.value !== "undefined") ? child.value : -1;
                var name = (typeof child.name !== "undefined") ? child.name : '[No Name]';
                if (settings.singleSelection) {
                    conHTML.push('<input type="radio" name="' + settings.radiogroup + '" value="' + value + '"' + checked + '' + disabled + '/><span ' + selectHfilterString + '>' + name + '</span>');
                } else {
                    conHTML.push('<input type="checkbox" value="' + value + '"' + checked + '' + disabled + '/><span ' + selectHfilterString + '>' + name + '</span>');
                }
            }

            function iterateChildren(obj) {
                conHTML.push('<ul class="collapsed">');
                for (var i in obj) {
                    var hidden = typeof obj[i].hidden !== "undefined" && obj[i].hidden;
                    var hiddenBySearch = (settings.search && typeof obj[i].hiddenBySearch !== "undefined" && obj[i].hiddenBySearch);
                    var matchedBySearch = (settings.search && typeof obj[i].matchedBySearch !== "undefined" && obj[i].matchedBySearch) ? ' matchedBySearch="true"' : '';
                    
                    hidden = hidden || hiddenBySearch ? ' hidden="hidden"' : '';

					if (typeof obj[i].expandable !== "undefined" && obj[i].expandable) {
						conHTML.push('<li class="nonexpandable" ' + hidden + matchedBySearch + '>');
					} else {
						conHTML.push('<li ' + hidden + matchedBySearch + '>');
                    }
                    pushChild(obj[i]);
                    if (typeof options.children[i].items !== "undefined") {
                        iterateChildren(obj[i].items);
                    }
                    conHTML.push('</li>');
                }
                conHTML.push('</ul>');
            }
            var conHTML = [];

            if (typeof options.node === "undefined") {
                options.node = rootElement.children('li').children('span');
            }

            if (!($(options.node).children('ul').length > 0)) {
                if (typeof options.children !== "undefined") {
                    if (options.children.length > 0) {
                        //recursive handling
                        iterateChildren(options.children);
                    }
                }
            }

            $(options.node).parent().append(conHTML.join(''));

			if (settings.compact) {
				settings.updateCompactText.apply(rootElement);
			}
		},
		updateCompactText: function (options) {
			var data = $(this).data(pluginName);
			if (!data) return;
			var settings = data.settings;
			var rootElement = data.target;
            var chkSplitFilter = $('#chkSplitFilter');

            if (settings.compact) {
                var cbt = rootElement.siblings('.DUITreeCompactButton').children('.DUITreeCompactButton-ui-text');
                var names = (typeof options !== "undefined" && typeof options.names !== "undefined") ? options.names : methods.getCheckedNames.apply(rootElement, [{ maxResults: 5 }]);
                if (names.length > 0) {
                    if (names.length > 4) {
                        cbt.text('4+ Selected');
                    } else {
                        cbt.text(names.join(', '));
                    }
                } else {
                    cbt.text('No selected HFilters');
                }

                if (!window.IsStoryboard) return;

                var mainHFilterSelectionMode = Storyboard.LayoutDesigner.getHFilterSelectionMode();
                var hideOneReportPerFilter = Storyboard.LayoutDesigner.getExportOptions().hideOneReportPerFilter;

                if (mainHFilterSelectionMode == Storyboard.Constants.HFilterSelectionModes.SINGLE) {
                    chkSplitFilter.attr("checked", true);
                    chkSplitFilter.parent().hide();
                } else {
                    const isBulkHFilterExportEnabled = Storyboard.LayoutDesigner.isBulkHFilterExportEnabled();
                    if (names.length > 1 && !hideOneReportPerFilter) {
                        if (!chkSplitFilter.is(':visible')) {
                            chkSplitFilter.attr("checked", false);
                            chkSplitFilter.parent().toggle(isBulkHFilterExportEnabled);
                        }
                    } else {
                        if (!chkSplitFilter.is(':visible')) {
                            chkSplitFilter.attr("checked", false);
                        }
                        else {
                            isBulkHFilterExportEnabled ? chkSplitFilter.attr("checked", true) : chkSplitFilter.attr("checked", false);
                            chkSplitFilter.parent().hide();
                        }
                    }
                }

                $('#divSplitInBatches').toggle(names.length > 1 && chkSplitFilter.attr("checked"));
                $('#divBatchSize').toggle($('#chkSplitInBatches').is(':visible') && $('#chkSplitInBatches').attr("checked"));

                const settingsControl = $('#regularFiltersPowerpoint .SettingsControl');
                const chkSelectFilterForIterate = settingsControl.find('#chkSelectFilterForIterate');

                if (names.length > 1) {
                    settingsControl.find('button').addClass('ui-state-disabled');

                    if (mainHFilterSelectionMode == Storyboard.Constants.HFilterSelectionModes.SINGLE) {
                        chkSelectFilterForIterate.attr({ 'disabled': 'disabled', 'checked': false });
                    }
                }
                else if (mainHFilterSelectionMode !== Storyboard.Constants.HFilterSelectionModes.MULTIPLE
                            && !chkSelectFilterForIterate.is(':checked'))
                            chkSelectFilterForIterate.removeAttr('disabled');
            }
        },
		updateHeight: function() {
			if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
				return;
			
			var data = $(this).data(pluginName);
			if (!data) return;

			var rootElement = data.target;
			var scrollTop = rootElement.scrollTop();
			rootElement.height('');
			var eh = rootElement.outerHeight(), wh = $(window).height(), eo = rootElement.offset().top - $(window).scrollTop();
			if (eh > wh - eo - 50) {
				rootElement.height(wh - eo - 50 + 'px');
			}
			rootElement.scrollTop(scrollTop);
		},
		checkNode: function(oThis) {
			var settings = $(this).data(pluginName).settings;
			var rootElement = $(this).data(pluginName).target;
			
			settings.check(oThis);

            if (rootElement.attr("id") === "sbSettingHFilterTree" && $("#ddlShownHFiltersType").val() == 4) {
                oThis.parent().find(" > span").addClass("selected");
                if (oThis.attr("checked")) {
                    methods.checkDescendants.apply(oThis.parent(), [{ rootElement: oThis.parent(), disable: true }]);
                    settings.cbCheckDescendants(oThis.parent().find('span.selected').prev('input').val());
                } else {
                    methods.uncheckDescendants.apply(oThis.parent(), [{ rootElement: oThis.parent(), disable: false }]);
                    settings.cbUncheckDescendants(oThis.parent().find('span.selected').prev('input').val());
                }
                oThis.parent().find(" > span").removeClass("selected");
            }

            if (settings.compact) {
                settings.updateCompactText.apply(rootElement);
            }
        },
        expandNode: function(oThis) {
            var settings = $(this).data(pluginName).settings;
            var rootElement = $(this).data(pluginName).target;
            
            //toggle states
            if (oThis.hasClass('nonexpandable')) {
                return false;
            }

			if (oThis.hasClass('expanded')) {
				rootElement.trigger('collapsed', { node: oThis, value: oThis.children('input').val() });
				oThis.removeClass('expanded');
				settings.updateHeight.apply(rootElement);
				settings.collapse();
			} else {
				methods.renderChildNodes.apply(rootElement, [{ node: oThis }]);

				if (oThis.children('ul').length < 1 && !oThis.hasClass('loading')) {
					// trigger only if no child nodes have been loaded and have not started loading yet
					rootElement.trigger('expanded', { node: oThis, value: oThis.children('input').val() });
				}
				oThis.addClass('expanded');
				settings.updateHeight.apply(rootElement);
				settings.expand();
			}
		},
		handleEvt: function (evt) {
			var settings = $(this).data(pluginName).settings;
			var rootElement = $(this).data(pluginName).target;
			var oThis = $(evt.target);
			var targetNodeName = (typeof evt !== "undefined" && typeof evt.srcElement !== "undefined") ? evt.srcElement.nodeName : (typeof evt.target !== "undefined") ? evt.target.nodeName : evt.currentTarget.nodeName;

            if (targetNodeName.toUpperCase() === 'SPAN') {
                if (settings.inlineMenu) {
                    rootElement.find('span').removeClass('selected');
                    oThis.addClass('selected');
                    rootElement.children('.DUITreeViewInlineMenu').removeClass('DUITreeViewInlineMenuDisabled');
                    settings.select();
                } else {
                    oThis = oThis.siblings('input');

                    if (!oThis.is(':disabled')) {
                        if (!settings.singleSelection || !oThis.is(':checked')) {
                            oThis.attr('checked', !oThis.is(':checked'));
                        }
                        methods.checkNode.apply(this, [oThis]);
                    }
                }
                
                evt.stopPropagation();
            }

            if (targetNodeName.toUpperCase() === 'INPUT') {
                if ($(this.element).parent().hasClass('nonexpandable')) {
                    return false;
                }

                methods.checkNode.apply(this, [oThis]);

                evt.stopPropagation();
            }

            if (targetNodeName.toUpperCase() === 'LI') {
                if (oThis.hasClass('DUITreeViewInlineMenu') || oThis.hasClass('DUITreeViewMI')) {
                    return;
                }

                methods.expandNode.apply(this, [oThis]);

                evt.stopPropagation();
                evt.preventDefault();
            }
        },
        checkSiblings: function (options) {
            var rootElement = $(this).data(pluginName).target;
            var node = rootElement.find('span.selected');
            if (node.length > 0) {
                node.parent().children('input').attr('checked', 'checked');
                if (typeof options.callback !== "undefined") {
                    options.callback(rootElement);
                }

                node.parent().siblings().each(function() {
                    $(this).children('input').attr('checked', 'checked');
                    if (typeof options.callback !== "undefined") {
                        options.callback($(this));
                    }
                });
            }
        },
        uncheckSiblings: function (options) {
            var node = options.rootElement.find('span.selected');
            if (node.length > 0) {
                node.parent().children('input').removeAttr('checked');
                node.parent().siblings().each(function () {
                    $(this).children('input').removeAttr('checked');
                })
            }
        },
        checkChildren: function (options) {
            var node = options.rootElement.find('span.selected');
            var check = function (inode) {
                inode.children('input').attr('checked', 'checked');
            }

            internals.iterateChildren(node, check);
        },
        uncheckChildren: function (options) {
            var node = options.rootElement.find('span.selected');
            var uncheck = function (inode) {
                inode.children('input').removeAttr('checked');
            }

            internals.iterateChildren(node, uncheck);
        },
        checkAncestors: function (options) {
            var node = options.rootElement.find('span.selected');
            var check = function (inode) {
                inode.prev().siblings('input').attr('checked', 'checked');
            }

            internals.iterateAncestors(node, check);

        },
        uncheckAncestors: function (options) {
            var node = options.rootElement.find('span.selected');
            var uncheck = function (inode) {
                inode.prev().siblings('input').removeAttr('checked');
            }

            internals.iterateAncestors(node, uncheck);
        },
        checkDescendants: function (options) {
            var node = options.rootElement.find('span.selected');
            var check = function (inode) {
                inode.children('input').attr('checked', 'checked');
                if (options.disable === true)
                    inode.children('input').attr('disabled', 'disabled');
            }
            internals.iterateDescendants(node, check);
        },
        uncheckDescendants: function (options) {
            var node = options.rootElement.find('span.selected');
            var uncheck = function (inode) {
                inode.children('input').removeAttr('checked');
                if (options.disable === false)
                    inode.children('input').removeAttr('disabled');
            }
            internals.iterateDescendants(node, uncheck);
        },
        checkNodeLevel: function (options) { 
            var rootElement = $(this).data(pluginName).target;
            var nodeLevel = prompt('Which node level should be checked (where root = 1)?');
            if (nodeLevel == null) {
                //silent quit
            } else if (isNaN(nodeLevel)) {
                alert("You did not enter a number!");
            } else {
                nodeLevel = parseInt(nodeLevel, 10);
                if (nodeLevel < 1) {
                    alert('You did not enter a number higher than 0!');
                } else {
                    var root = rootElement.children('li:not(.DUITreeViewInlineMenu)');
                    var currentNode = root;

                    for (var i = 1; i < 1000; i++) {
                        if (nodeLevel == i) {
                            currentNode.children('input').attr('checked', 'checked');
                            if (typeof options.callback !== "undefined") {
                                options.callback(nodeLevel);
                            }
                            if (typeof options.callback1 !== "undefined") {
                                $(currentNode).each(function() { options.callback1($(this)); });
                            }
                            break;
                        } else {
                            currentNode = currentNode.children('ul').children('li');
                        }
                    }
                }
            }
        },
        checkAll: function (options) {
            var node = options.rootElement.children('li');
            node.children('input').attr('checked', 'checked');
            var check = function (inode) {
                inode.children('input').attr('checked', 'checked');
            }
            internals.iterateDescendants(node, check);
        },
        uncheckAll: function (options) {
            var node = options.rootElement.children('li');
            node.children('input').removeAttr('checked');
            var check = function (inode) {
                inode.children('input').removeAttr('checked');
            }
            internals.iterateDescendants(node, check);
        },
        getCheckedValues: function (options) {
            var rootElement = $(options.rootElement).data(pluginName).target;
            var checked = [];
            rootElement.find('input').each(function () {
                if ($(this).is(':checked')) {
                    checked.push($(this).val());
                }
            });
            return checked;
        },
        getCheckedNames: function (options) {
            //var rootElement = $(options.rootElement).data(pluginName).target;
            var rootElement = this;
            var checked = [], iters = 0;
            if (typeof options.maxResults !== "undefined") {
                options.maxResults = 2;
            }

            rootElement.find('input').each(function () {
                if ($(this).is(':checked')) {
                    checked.push($(this).siblings('span').text());
                    iters++;
                }

                if (iters == options.maxResults) {
                    return checked;
                }
            });
            return checked;
        }
    }

    $.fn.DUITreeView = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        }
    }
})(jQuery);